import { ContactTypeIcon } from "@/components/contact/ContactTypeIcon";
import Ellipsis from "@/components/views/Ellipsis";
import { formatPhoneNumber } from "@/utils/formatUtils";
import { cssVariables } from "@/utils/utils";
import { Avatar, Card } from "antd";
import { Link } from "react-router";
import UserOutlined from "../../../../../../assets/images/UserOutlined.svg";
import { ContactType } from "../../../../../../common/enums";
import { Permission } from "../../../../../../common/security/enums";
import { UUID } from "../../../../../../typings/global";
import { useHasPermissions } from "../../../../../auth/hooks";
import { DashboardContactActions } from "./DashboardContactActions";

interface Props {
  contactId: UUID;
  name: string;
  onUpdate: VoidFunction;
  imageSrc?: string;
  email?: string;
  phone?: string;
  description?: string;
}

export const DashboardContactCard = ({ contactId, name, imageSrc, email, phone, description, onUpdate }: Props) => {
  const hasAdminDashboardPermission = useHasPermissions(Permission.ADMIN_DASHBOARD);

  return (
    <Card
      actions={[
        <Ellipsis key={email} tooltip={email}>
          <span style={{ paddingLeft: 20, paddingRight: 14 }}>
            <span style={{ paddingRight: 8 }}>
              <ContactTypeIcon type={ContactType.EMAIL} />
            </span>

            {email ? (
              <Link style={{ display: "inline", color: cssVariables.colorText }} to={`mailto:${email}`}>
                <>{email}</>
              </Link>
            ) : (
              <span>---</span>
            )}
          </span>
        </Ellipsis>,
        <Ellipsis tooltip={phone ? formatPhoneNumber(phone) : ""}>
          <span style={{ paddingLeft: 14, paddingRight: 20 }}>
            <span style={{ paddingRight: 8 }}>
              <ContactTypeIcon type={ContactType.PHONE_NUMBER} />
            </span>

            {phone ? (
              <Link style={{ display: "inline", color: cssVariables.colorText }} to={`tel:${phone}`}>
                {formatPhoneNumber(phone)}
              </Link>
            ) : (
              <span>---</span>
            )}
          </span>
        </Ellipsis>,
      ]}
    >
      <Card.Meta
        avatar={
          <Avatar
            size="large"
            src={imageSrc ? <img style={{ objectFit: "contain" }} src={imageSrc} alt="Avatar" /> : UserOutlined}
          />
        }
        title={<Ellipsis style={{ fontSize: 16 }}>{name}</Ellipsis>}
        description={<Ellipsis>{description}</Ellipsis>}
      />

      {hasAdminDashboardPermission ? <DashboardContactActions contactId={contactId} onUpdate={onUpdate} /> : undefined}
    </Card>
  );
};
